import { render } from "./Impressum.vue?vue&type=template&id=39b86272"
const script = {}

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__